import { Injectable } from '@angular/core';
import { Observable, from, BehaviorSubject, Subject } from 'rxjs';
import { SharedService } from '../sheared/sharedService.service';
//import { map } from 'rxjs/operators';
import { AngularFireDatabase, AngularFireAction, DatabaseSnapshot } from '@angular/fire/database';
import { authenticationService, Clients } from '../Authentication/authentication.service';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoadingController, ModalController } from '@ionic/angular';
import { NotificationService } from '../Notifications/notification.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { config } from 'src/environments/config';
import { isUndefined } from 'util';
import { AssureurService } from '../Assureur/assureur.service';
import { ValidationPage } from 'src/app/Pages/validation/validation.page';
import { SqlitebaseService } from '../Sqlite/Sqlitebase.service';




@Injectable({
  providedIn: 'root'
})
export class PaiementService implements Resolve<any> {

  private _quittances = new BehaviorSubject<{code:200}>({code:200}); // quittance[]=any
  loading: HTMLIonLoadingElement
 quittances:any[];
  loadingOk = new BehaviorSubject<boolean>(false);
  LesquittancesPartager = new BehaviorSubject<any[]>([]); // quittance[]=any
private lstAss:any[]


  constructor(private sharedService: SharedService,
    private db: AngularFireDatabase,
    private loadingController: LoadingController,
    private notify:NotificationService, 
    private modalController: ModalController,
    private auth:authenticationService,private sql: SqlitebaseService,
    private assur:AssureurService) {
      this.assur.ListAssreurs.subscribe(
        res =>{
              this.lstAss=res
        }
      )
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
    var profil =  this.auth.profile
    try {
      if (profil) {
        this.loading = await this.loadingController.create({
          message: 'Chargement...',
          duration: 30000,
          mode:"ios",
          spinner: 'bubbles'
        });

        await this.loading.present();
    
          this.loading.dismiss()// Pour gérer le retour vers la vue
           return await  this.getPolices(profil)
        
        
        
        //return result
      }else{
        return null
      }
      
    } catch (error) {
      return null
    }
    
  }


   addQuit(key: string, CodeAssur: string) {
    
    this.db.list('ListQuitNew/'+ this.auth.profile.uid).push(
      {
       CodeAssur:CodeAssur,
       keyQuit:key
      }
    )
   }
 

   getPolices(profil: Clients) {    
   return this.db.list(`Quittances`,ref => ref.orderByChild('idKey')
   .equalTo(profil.uid)).snapshotChanges(['child_added'])
  }
  getPolicesPartager() {    
     this.db.list(`Quittances`,ref => ref.orderByChild('idkeyPar')
    .equalTo(this.auth.profile.uid)).snapshotChanges(['child_added'])
    .subscribe((snapshots) => {
      let item0 = [];
      let i=1
      snapshots.forEach((snap) => {
        // this.auth.profile.CodeAssu == snap.payload.exportVal().CodeAssur &&
        let lstPaie = [];

        for (const key in snap.payload.exportVal().listPaie) {
          if (
            Object.prototype.hasOwnProperty.call(
              snap.payload.exportVal().listPaie,
              key
            )
          ) {
            const element = snap.payload.exportVal().listPaie[key];
            if (element.solde) {
              lstPaie.push({
                modePayement: element.modePayement,
                montantPayement: element.montantPayement,
                mtnLivraison: element.mtnLivraison,
              });
            }               
          }
        }

        if (!snap.payload.exportVal().solde) {
          var datejr = this.sharedService.getDate();
          var ex = this.sharedService.ConvertDMYorYMD(
            snap.payload.exportVal().dateExpi,
            "y/m/d"
          );
          let objetAssur = this.lstAss.find((e) => e.CodeAssu == snap.payload.exportVal().CodeAssur);

          item0.push({
            id: i,
            $key: snap.key,
            police:snap.payload.exportVal().NumPolice,
            NumPolice:
              snap.payload.exportVal().NumPolice +
              " [ " + objetAssur.NomAssu + " ]",
            // mtntLivraison: objetAssur.mtnLivreur,
            numClient: snap.payload.exportVal().numClient,
            CodeAssur: snap.payload.exportVal().CodeAssur,
            duree: this.sharedService.diffDays(datejr, ex) * 1 + 1,
            Immat:
              snap.payload.exportVal().Immat != ""
                ? snap.payload.exportVal().Immat
                : "",
            montant_due: snap.payload.exportVal().montant_due,
            nbPaie:lstPaie.length,
            montant_restant:snap.payload.exportVal().montant_due - (lstPaie.reduce((acc, curr) => Number(acc) + Number(curr.montantPayement), 0 )),
            montantVerse: lstPaie.reduce((acc, curr) => Number(acc) + Number(curr.montantPayement),0),
            montant_paye: snap.payload.exportVal().montant_paye, //this.sharedService.eparateurMil(snap.payload.exportVal().montant_paye),
            dateEffet: snap.payload.exportVal().dateEffet,
            dateExpi: snap.payload.exportVal().dateExpi,
            icon: snap.payload.exportVal().icon,
            isChecked: false,
            idproprio:snap.payload.exportVal().idKey,
            partage:snap.payload.exportVal().idkeyPar,
            namePar:snap.payload.exportVal().namePar,
            idKey:snap.payload.exportVal().idKey,
          });
          i++;
        }
      });

        this.LesquittancesPartager.next(item0)
      // if (this.itemHist) {
      //   //renvoie la quittance à payer selectionnée en historique
      //   this.item0 = this.item0.filter((a) => a.$key == this.itemHist.$key);
      // }
      // setTimeout(() => {
      //   this.items = this.item0;
      // });
      // //this.items.length
      // this._paiementservice.loading.dismiss();
    });


   }
  
   getPolicesNew() {    
    return  this.db.list('ListQuitNew/'+this.auth.profile.uid).snapshotChanges()
  
  }



   UniqueDonne(initDatas) {
    const result0 = [];
    const map = new Map();
    for (const item of initDatas) {
      if (!map.has(item.$key)) {
        map.set(item.$key, true);    // set any value to Map
        result0.push(item);
      }
    }
    return result0;
  }

  private IdentifyIcone(){
    icone:[{"icon":""},{"":""},{"":""},{"":""},{"":""},]
  }

  private PrepareData(data: any[]): any[] {
    
    data.forEach((obj) => {
      var datejr=this.sharedService.getDate() 
      var ex=this.sharedService.ConvertDMYorYMD(obj.dateExpi,"y/m/d")
      obj.duree = this.sharedService.diffDays(datejr, ex)
      obj.dateEffet=obj.dateEffet
      obj.dateExpi=obj.dateExpi
      obj.montant_due = this.sharedService.eparateurMil(obj.montant_due);
      obj.montant_paye = this.sharedService.eparateurMil(obj.montant_paye);
    })
    
    return data

  }

 async apiMOBILEmoney(obj:any){
  this.loading = await this.loadingController.create({
    message: 'Traitement en cours...',
    // duration: 2000,
    mode:"ios",
    spinner: 'bubbles'
  });
const httpOptions={
  headers:new HttpHeaders ({
    // 'Access-Control-Allow-Origin':'*',
    'Content-type':'application/json',
  })
} 
  await this.loading.present();

  return this._quittances

 
      
 }

 async insertPrime(laPrime:any){
   //laPrime
  return await this.db.list(`Quittances`).push(laPrime[0])
    
}
async payerPrimeWithReturn(lesPrime:any[],modep:string,laref:string,dataRetour:any,objetlivraison:any){
  
 let MontantDu= lesPrime.filter(e => e.isChecked).reduce((acc,curr)=> acc+curr.montant_due,0)
 if ((MontantDu+objetlivraison.livrer)==dataRetour.refMontant) { 
        lesPrime.filter(e => e.isChecked).forEach(prime =>{
          console.log(prime.$key);

            this.db.list(`Quittances/${prime.$key}/listPaie`).push({
              datePayment: this.sharedService.getDateWithTime(), //"24-08-2020 24:03:48",
              modePayement: modep,//"AirtelMoney",
              montantPayement: prime.montant_due,
              montantMontant_due:prime.montant_due,
              refAsapPayement: laref,//laref.substr(-6),
              refMobilePayement: dataRetour.refMobile,//"MP200825.0002.C53934"
              // lieu:isUndefined(objetlivraison.lieu)? "":objetlivraison.lieu,
              // heure:isUndefined(objetlivraison.heure)? "":objetlivraison.heure,
              mtnLivraison:objetlivraison.livrer,
              solde:true
            })
            
            .then((result)=>{

                this.db.object(`Quittances/${prime.$key}`).update({
                  montant_paye:prime.montant_due,//.replace(/ /g, "") * 1,
                  date_paiement:this.sharedService.getDate(),
                  lieu:isUndefined(objetlivraison.lieu)? "":objetlivraison.lieu,
                  heure:isUndefined(objetlivraison.heure)? "":objetlivraison.heure,
                  tel:this.auth.profile.tel1,
                  solde:true,
                  NumRef:laref.substr(-6),
                  etatdoc:"encours",
                
                })
            })
            

      })


 } else {
   
 }


  }
  
  async payerPrimeWithOutReturn(lesPrime:any[],modep:string,laref:string,dataRetour:any,objetlivraison:any,montPaie,avance:boolean){
    //this.loadingOk.next(true)
    
    let Selected=lesPrime.filter(e => e.isChecked)

    // if (Selected.length>1) { }
        Selected.map(e =>{
          e.montPaie=Math.round((e.montant_restant/Selected.reduce((acc,curr)=> acc+curr.montant_restant,0))*montPaie)
        })
   
   let MontantDu= lesPrime.filter(e => e.isChecked).reduce((acc,curr)=> acc+curr.montant_due,0)
  // if ((MontantDu+objetlivraison.livrer)==montPaie/*dataRetour.refMontant*/) {  }
          Selected.forEach(prime =>{
            
            if (prime.$key) {
              this.db.list(`Quittances/${prime.$key}/listPaie`).push({
                datePayment: this.sharedService.getDateWithTime(), //"24-08-2020 24:03:48",
                modePayement: modep,//"AirtelMoney",
                montantPayement: prime.montPaie,
                mtnLivraison:objetlivraison.livrer,
                solde:false,
                montantMontant_due: prime.montant_due,
                refAsapPayement: laref,//laref.substr(-6),
                refMobilePayement:"" //dataRetour.refMobile
               
              }).then((result)=>{
                this.db.list(`TempPayement/${laref}`).push({
                  keyQuit: prime.$key,
                  keyPaie:result.key,//"AirtelMoney",
                  keyMountPrime:prime.montPaie,
                  keyMontLivre:objetlivraison.livrer,
                  keyDateinsert:this.sharedService.getDateWithTime()
                  
                })
                  this.WaitingForReturn(prime.$key,laref,prime.NumPolice,modep,lesPrime,avance)
              })
                    this.db.object(`Quittances/${prime.$key}`).update({
                    //montant_paye:prime.montant_due,//.replace(/ /g, "") * 1,
                    date_paiement:this.sharedService.getDate(),
                    lieu:isUndefined(objetlivraison.lieu)? "":objetlivraison.lieu,
                    heure:isUndefined(objetlivraison.heure)? "":objetlivraison.heure,
                    solde:false,
                    tel:this.auth.profile.tel1,
                    NumRef:laref.substr(-6),
                    etatdoc:""
                  
                  })
            }
  
        })
  
  
  
    
  
  
    }

  private WaitingForReturn($keyQuit,laref,police:string,modep,lesPrime,avance:Boolean){
 let subs=this.db.list(`Quittances/${$keyQuit}/listPaie`,ref => ref.orderByChild('refAsapPayement').equalTo(laref)
    ).snapshotChanges(['child_changed']).subscribe(
      datas =>{
         if (datas.length>0) {
          datas.map(e =>{        
            if (e.payload.exportVal().solde) {
              police=police.substring(0,police.indexOf(' '))
             this.presentValidationPage(laref,modep,e.payload.exportVal().montantPayement,police,avance)
                let icon = this.lstAss.find((e) => e.CodeAssu == e.payload.exportVal().CodeAssur).icon;    
                this.notify.NotifiPaiement(1, police,icon,avance);
                this.NotifyService(lesPrime)
            //subs.unsubscribe()
            }
         })
         
         }
  
      }
    )
  }

private NotifyService(items){
  items.filter(e => e.isChecked).forEach((e) => {

      this.sql.updateNotifyAutomation(e.$key, "0", "0").then(() => this.notify.goAtMidnight());
    
  });
}

  private async presentValidationPage(ref,modep,Mtotal,lapolice,avance:Boolean) {
    if (Mtotal <= 0) return;
    this.loadingOk.next(false)
    const modal = await this.modalController.create({
      component: ValidationPage,
      componentProps: {
        value: {
          Montant: Mtotal,
          police: lapolice,
          mode: modep,
          ref: ref.substr(-6),
          avance:avance
        },
      },
    });

    await modal.present();
  }
}
